import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Resource } from "../../resources";
import { ListViewDelegate } from "./list-view";
import { GridApi } from "ag-grid-community";

@Component({
  selector: "grid-list-view",
  templateUrl: "./grid-list-view.html",
   standalone: false,
  styleUrls: ["./grid-list-view.css"],
})
export class GridListView<T> {
  @Input() gridDelegate: ListViewDelegate<T>;
  @Input() columnDefs;
  @Input() frameworkComponents;
  @Input() errorMsg: string;
  @Input() gridKeyColumn: string;
  @Output() refreshView: EventEmitter<void> = new EventEmitter<void>();
  @Output() saveEntity: EventEmitter<Resource> = new EventEmitter<Resource>();
  @Output() removeEntity: EventEmitter<Resource> = new EventEmitter<Resource>();
  public context: any = { parent: this };
  public gridApi;
  public gridColumnApi: GridApi;
  public defaultColDef;
  public components;
  public rowSelection;
  public entity: Resource;

  constructor() {
    this.initManifestGrid();
  }
  save(entity: Resource) {
    this.saveEntity.emit(entity);
  }

  remove(entity: Resource) {
    this.removeEntity.emit(entity);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onRowValueChanged(event) {
    if (
      event.node.changedValues &&
      event.data[this.gridKeyColumn] &&
      event.data[this.gridKeyColumn].trim().length > 0
    ) {
      this.save(event.data);
      event.node.changedValues = null;
    } else {
      this.refreshView.emit();
    }
  }

  onCellValueChanged(event) {
    if (event.newValue !== event.oldValue) {
      if (!event.node.changedValues) event.node.changedValues = [];

      event.node.changedValues.push(event.colDef.field);
    }
  }
  addNew(colKey: string) {
    this.gridColumnApi.resetColumnState();
    this.gridApi.applyTransaction({ add: [{}], addIndex: 0 });
    this.gridApi.startEditingCell({ rowIndex: 0, colKey });
    this.gridApi.setFocusedCell(0, colKey);
  }

  initManifestGrid() {
    this.defaultColDef = {
      flex: 1,
      wrapText: true,
      resizable: true,
      sortable: true,
      floatingFilter: true,
      autoHeight: true,
      editable: true,
      filter: "agTextColumnFilter",
      sortingOrder: ["asc", "desc"],
    };
  }
}
